module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j64Gl"))).then(() => parcelRequire('d0iPb'));